import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {} from "../../store/layout/actions";

//Simple bar
import SimpleBar from "simplebar-react";

//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.history = props.history;
  }

  render() {
    return (
      <React.Fragment>
        {this.history.location.pathname !== "/attachments-interaction" && (
          <div className="vertical-menu">
            <div data-simplebar className="h-100 scrollable">
              {this.props.type !== "condensed" ? (
                <SimpleBar style={{ maxHeight: "100%" }}>
                  <SidebarContent />
                </SimpleBar>
              ) : (
                <SidebarContent />
              )}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
